// Phase 7 — Corner logo shown at the top of every New*.jsx form.
// Print-friendly via `@media print` rule in index.css (.print-logo).
export default function FormLogo() {
  return (
    <img
      src="/vgws-logo.png"
      alt="VGWS"
      className="print-logo hidden sm:block absolute top-4 right-4 w-[100px] h-auto z-10 opacity-95"
      data-testid="form-logo"
    />
  );
}
